import EmailSignUp from '@/components/ui/EmailSignUp'
import RichText from '@/components/content/common/RichText'

import type { Block } from '@/types/app'
import { cn } from '@/lib/utils'

type SubscriptProps = {
  copy: string | Block[]
  button?: string | null
  className?: string
}

export default function Subscribe({ copy, button, className }: SubscriptProps) {
  return (
    <div className={cn('mx-auto w-full max-w-content px-3 md:px-5', className)}>
      <div className="flex w-full flex-col rounded border dark:border-white/15">
        <div className="flex h-14 items-center justify-start rounded-t border-b border-gray-200 bg-gray-50 px-5 text-18 font-semibold text-gray-950 dark:border-white/15 dark:bg-white/5 dark:text-white">
          Subscribe for updates
        </div>
        <div className="flex flex-col gap-4 px-7 pb-8 pt-6 text-gray-800 dark:text-gray-200">
          {typeof copy === 'string' ? <p>{copy}</p> : <RichText content={copy} />}
          <EmailSignUp focus="Updates" button={button} />
        </div>
      </div>
    </div>
  )
}
